'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { releaseSpartanParallaxPause, scrollSpartanExteriorThreesixtyIntoView } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/scroll-to-viewport-center';
import { SPARTAN_PRODUCT_EXTERIOR_TRACKING } from '@/app/lcv/components/sections/spartan/products/exterior/tracking';
import { notifySpartanProductScroll } from '@/app/lcv/components/sections/spartan/products/shared/product-scroll/store';
import { SPARTAN_PRODUCT_EXTERIOR_SECTION_ID } from '@/app/lcv/components/sections/spartan/products/shared/section-anchors';
import { SPARTAN_SCROLL_TO_SECTION_DELAY_MS } from '@/app/lcv/components/sections/spartan/shared/scroll-to-section/constants';
import { SPARTAN_SECTION_SCROLL_MARGIN_CSS } from '@/app/lcv/components/sections/spartan/shared/scroll-to-section/section-scroll-margin';
import { clearSpartanPendingSection, getSpartanSectionFromLocation, peekSpartanPendingSection } from '@/app/lcv/components/sections/spartan/shared/section-query';
const hasExteriorThreesixtyTrack = (): boolean => Boolean(document.querySelector(`[data-test="${SPARTAN_PRODUCT_EXTERIOR_TRACKING.threesixtyTrack}"]`));
export const SpartanScrollToSection = () => {
  const $ = _c(6);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = () => {
      const section = getSpartanSectionFromLocation(searchParams);
      if (!section) {
        return;
      }
      const hadPending = Boolean(peekSpartanPendingSection());
      const timeoutId = window.setTimeout(() => {
        if (section === SPARTAN_PRODUCT_EXTERIOR_SECTION_ID && hasExteriorThreesixtyTrack()) {
          scrollSpartanExteriorThreesixtyIntoView();
          releaseSpartanParallaxPause();
          notifySpartanProductScroll();
        } else {
          const element = document.getElementById(section);
          if (element) {
            element.scrollIntoView({
              behavior: "instant",
              block: "start"
            });
          }
        }
        if (hadPending) {
          clearSpartanPendingSection();
        }
      }, SPARTAN_SCROLL_TO_SECTION_DELAY_MS);
      return () => {
        window.clearTimeout(timeoutId);
      };
    };
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== pathname || $[3] !== searchParams) {
    t1 = [pathname, searchParams];
    $[2] = pathname;
    $[3] = searchParams;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <style>{SPARTAN_SECTION_SCROLL_MARGIN_CSS}</style>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};